import * as ReactBootstrap from "react-bootstrap";
import {Field, reduxForm} from "redux-form";
import {ICONS, renderers, validations} from "../../components";
import React from "react";

const GlobalSearchFormDisplayHTML = ({handleSubmit, submitting}) => {
    return (
        <form onSubmit={handleSubmit}>
            <ReactBootstrap.Row>
                <ReactBootstrap.Col xs={11}>
                    <Field
                        name="search"
                        validate={[validations.required]}
                        component={renderers.renderField}
                        type="text"
                    />
                </ReactBootstrap.Col>
                <ReactBootstrap.Col xs={1}>
                    <ReactBootstrap.Button
                        className={'mt-3'}
                        variant="outline-success"
                        type="submit"
                        disabled={submitting}
                    >
                        {ICONS.SEARCH}
                    </ReactBootstrap.Button>
                </ReactBootstrap.Col>
            </ReactBootstrap.Row>
        </form>
    )
}
export const GlobalSearchFormDisplay = reduxForm({
    form: 'global-search-form',
})(GlobalSearchFormDisplayHTML)
